export default "__VITE_ASSET__CAm4QIDo__"